<template>
  <div>
    <KTCodePreview v-bind:title="mainModel.name || 'Chi tiết nhóm voucher'">
      <template v-slot:toolbar>
        <div class="row">
          <div class="ml-3">
            <b-button size="sm" variant="secondary" @click="goList"
              >Danh sách nhóm</b-button
            >
          </div>
          <div class="ml-3" v-if="checkPermission('COUPON_UPDATE')">
            <b-button size="sm" variant="secondary" @click="openForm"
              >Sửa nhóm</b-button
            >
          </div>
          <!-- Nhóm đang khóa không nhận thêm chương trình (BR-008) -->
          <div
            class="ml-3"
            v-if="mainModel.isActive && checkPermission('COUPON_UPDATE')"
          >
            <b-button size="sm" variant="primary" @click="openPicker">
              <i style="font-size: 1rem" class="flaticon2-add-1"></i>Thêm chương
              trình
            </b-button>
          </div>
        </div>
      </template>
      <template v-slot:preview>
        <div class="mb-4">
          <span
            v-text="mainModel.isActive ? 'Mở' : 'Khóa'"
            :class="[
              'label font-weight-bold label-lg label-inline mr-3',
              mainModel.isActive ? 'label-light-success' : 'label-light-danger',
            ]"
          ></span>
          <span class="text-muted">
            {{ mainModel.description || 'Không có mô tả' }}
          </span>
        </div>

        <b-alert :show="!mainModel.isActive" variant="light-warning" class="py-2">
          Nhóm đang khóa nên <b>không nhận thêm chương trình</b> — nút Thêm
          chương trình bị ẩn. Chương trình bên trong vẫn áp được voucher bình
          thường, chỉ chuyển sang nhãn “Chưa phân nhóm” ngoài màn bán hàng.
        </b-alert>

        <div class="col-md-12 mb-5 px-0">
          <b-form>
            <b-row>
              <b-col class="pl-0" cols="4">
                <b-input
                  placeholder="Tìm trong nhóm theo tên chương trình"
                  v-model="searchName"
                  class="btn-sm"
                  v-on:keyup.enter="onFilter"
                ></b-input>
              </b-col>
              <b-col cols="2">
                <b-button
                  style="fontweight: 600; width: 70px"
                  variant="primary"
                  size="sm"
                  @click="onFilter"
                  >Lọc</b-button
                >
              </b-col>
            </b-row>
          </b-form>
        </div>

        <b-table
          :items="vouchers"
          :fields="voucherFields"
          bordered
          hover
          show-empty
          :busy="onLoading"
          empty-text="Nhóm này chưa có chương trình nào. Thêm chương trình để bắt đầu sắp xếp."
        >
          <template v-slot:table-busy>
            <vcl-table :speed="5" :animate="true" :columns="5"></vcl-table>
          </template>
          <template v-slot:head(checkbox)>
            <div class="text-center">
              <b-form-checkbox
                :checked="isAllOnPageSelected"
                @change="toggleAllOnPage"
              ></b-form-checkbox>
            </div>
          </template>
          <template v-slot:cell(checkbox)="row">
            <div class="text-center">
              <b-form-checkbox
                :checked="selectedIds.includes(row.item.voucherId)"
                @change="toggleOne(row.item.voucherId, $event)"
              ></b-form-checkbox>
            </div>
          </template>
          <template v-slot:cell(period)="row">
            <span>Từ: {{ row.item.startDate }}</span>
            <span style="display: block">Đến: {{ row.item.endDate }}</span>
          </template>
          <template v-slot:cell(status)="row">
            <span
              v-text="row.item.status ? 'Mở' : 'Khóa'"
              :class="[
                'label font-weight-bold label-lg label-inline',
                row.item.status ? 'label-light-success' : 'label-light-danger',
              ]"
            ></span>
          </template>
        </b-table>

        <b-alert
          :show="selectedIds.length > MAX_BULK"
          variant="light-danger"
          class="py-2 mt-3"
        >
          Mỗi lần chỉ xử lý tối đa {{ MAX_BULK }} chương trình, vui lòng bớt bớt
          lựa chọn!
        </b-alert>

        <b-row class="mt-3">
          <b-col>
            <p class="text-dark mb-0" style="font-weight: 500">
              Đã chọn <b>{{ selectedIds.length }}</b> trong
              {{ totalVoucher }} chương trình · tối đa {{ MAX_BULK }} mỗi lần
            </p>
            <b-form-text>Tích chọn áp trong phạm vi trang đang xem</b-form-text>
          </b-col>
          <b-col class="text-right">
            <b-button
              size="sm"
              variant="primary"
              :disabled="!selectedIds.length || selectedIds.length > MAX_BULK"
              @click="openMoveModal"
              >Chuyển sang nhóm khác</b-button
            >
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col>
            <b-pagination
              v-show="totalVoucherPages >= 2"
              v-model="voucherPage"
              :total-rows="totalVoucher"
              :per-page="PAGE_SIZE"
              align="right"
              size="sm"
              @change="onPageChange"
            ></b-pagination>
          </b-col>
        </b-row>

        <VoucherGroupFormModal ref="formModal" @saved="loadDetail" />
        <VoucherPickerModal
          ref="voucherPicker"
          :group-id="mainModel.id"
          :group-name="mainModel.name"
          @added="onVouchersAdded"
        />

        <b-modal ref="moveModal" title="Chuyển sang nhóm khác" hide-footer>
          <b-form-group>
            <label class="font-weight-bold"
              >Nhóm đích <span class="text-danger">*</span></label
            >
            <b-form-select
              class="select-style"
              size="sm"
              v-model="targetGroupId"
              :options="selectableGroups"
              value-field="id"
              text-field="name"
            ></b-form-select>
            <b-form-text>
              Chỉ liệt kê nhóm đang ở trạng thái Mở. Không có lựa chọn “Chưa
              phân nhóm” — không cho gỡ chương trình ra khỏi nhóm mà không chỉ
              định nhóm khác.
            </b-form-text>
          </b-form-group>
          <b-alert show variant="light-primary" class="py-2">
            Sẽ chuyển <b>{{ selectedIds.length }} chương trình</b> từ nhóm
            {{ mainModel.name }} sang nhóm đã chọn. Đợt 1 chưa lưu vết đổi nhóm
            nên đây là chốt chặn cuối.
          </b-alert>
          <div class="mt-3">
            <b-button
              size="sm"
              variant="primary"
              class="mr-2"
              :disabled="!targetGroupId || isSubmitting"
              @click="confirmMove"
              >Xác nhận chuyển</b-button
            >
            <b-button
              size="sm"
              variant="secondary"
              @click="$refs.moveModal.hide()"
              >Hủy</b-button
            >
          </div>
        </b-modal>
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import localData from '@/utils/saveDataToLocal';
import { VclTable } from 'vue-content-loading';
import VoucherGroupFormModal from '@/view/components/voucher-group/VoucherGroupFormModal.vue';
import VoucherPickerModal from '@/view/components/voucher-group/VoucherPickerModal.vue';
import { makeToastFaile, makeToastSuccess, getApiErrorMessage } from '@/utils/common';

/** Trần một lượt thao tác hàng loạt, khớp MAX_BULK_VOUCHERS bên API (BR-016). */
const MAX_BULK = 200;
const PAGE_SIZE = 10;

export default {
  components: {
    KTCodePreview,
    VclTable,
    VoucherGroupFormModal,
    VoucherPickerModal,
  },
  data() {
    return {
      MAX_BULK,
      PAGE_SIZE,
      isSubmitting: false,
      onLoading: false,
      searchName: '',
      mainModel: {
        id: null,
        name: '',
        description: '',
        isActive: true,
        // Dấu phiên bản, gửi lại khi sửa nhóm để chống ghi đè (BR-013)
        updatedAt: null,
      },
      vouchers: [],
      totalVoucher: 0,
      voucherPage: 1,
      selectedIds: [],
      selectableGroups: [],
      targetGroupId: null,
      voucherFields: [
        { key: 'checkbox', label: '', thStyle: { width: '5%' } },
        {
          key: 'voucherName',
          label: 'Tên chương trình',
          thStyle: { fontWeight: 600, color: '#181c32', width: '39%' },
        },
        {
          key: 'period',
          label: 'Thời gian',
          thStyle: { fontWeight: 600, color: '#181c32', width: '22%' },
        },
        {
          key: 'valueLabel',
          label: 'Giá trị',
          thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
        },
        {
          key: 'status',
          label: 'Trạng thái',
          thStyle: { fontWeight: 600, color: '#181c32', width: '14%' },
        },
      ],
    };
  },
  computed: {
    totalVoucherPages() {
      return Math.ceil(this.totalVoucher / PAGE_SIZE);
    },
    isAllOnPageSelected() {
      return (
        this.vouchers.length > 0 &&
        this.vouchers.every((voucher) =>
          this.selectedIds.includes(voucher.voucherId),
        )
      );
    },
  },
  created() {
    this.mainModel.id = this.$route.query.id || null;
    if (!this.mainModel.id) {
      this.goList();
      return;
    }
    this.loadDetail();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Khuyến mãi' },
      { title: 'Voucher sản phẩm' },
      { title: 'Nhóm voucher', route: '/voucher/voucher-group' },
      { title: 'Chi tiết nhóm' },
    ]);
  },
  methods: {
    checkPermission(condition) {
      return localData.checkPermission(condition);
    },
    goList() {
      this.$router.push({ name: 'list-voucher-group' });
    },
    async loadDetail() {
      this.onLoading = true;
      try {
        const { data } = await ApiService.query(
          `v2/voucher-groups/${this.mainModel.id}`,
          {
            params: {
              page: this.voucherPage,
              limit: PAGE_SIZE,
              searchName: this.searchName,
            },
          },
        );
        const group = data.data;
        this.mainModel = {
          id: group.id,
          name: group.name,
          description: group.description,
          isActive: Boolean(group.isActive),
          updatedAt: group.updatedAt,
        };
        this.vouchers = group.vouchers.dataset;
        this.totalVoucher = group.vouchers.totalRow;
      } catch (err) {
        makeToastFaile(getApiErrorMessage(err));
      } finally {
        this.onLoading = false;
      }
    },
    onFilter() {
      this.voucherPage = 1;
      this.selectedIds = [];
      this.loadDetail();
    },
    onPageChange(page) {
      this.voucherPage = page;
      // Tích chọn chỉ áp trong trang đang xem nên đổi trang là bỏ chọn
      this.selectedIds = [];
      this.$nextTick(this.loadDetail);
    },
    toggleOne(voucherId, checked) {
      this.selectedIds = checked
        ? [...this.selectedIds, voucherId]
        : this.selectedIds.filter((id) => id !== voucherId);
    },
    toggleAllOnPage(checked) {
      this.selectedIds = checked
        ? this.vouchers.map((voucher) => voucher.voucherId)
        : [];
    },
    openForm() {
      this.$refs.formModal.show(this.mainModel);
    },
    openPicker() {
      this.$refs.voucherPicker.show();
    },
    onVouchersAdded() {
      this.selectedIds = [];
      this.loadDetail();
    },
    async openMoveModal() {
      try {
        const { data } = await ApiService.get('v2/voucher-groups/selectable');
        // Nhóm hiện tại không phải đích hợp lệ của chính nó
        this.selectableGroups = data.data.filter(
          (group) => group.id !== Number(this.mainModel.id),
        );
        this.targetGroupId = null;
        this.$refs.moveModal.show();
      } catch (err) {
        makeToastFaile(getApiErrorMessage(err));
      }
    },
    async confirmMove() {
      this.isSubmitting = true;
      try {
        const { data } = await ApiService.put(
          'v2/voucher-groups/move-vouchers',
          {
            targetVoucherGroupId: this.targetGroupId,
            voucherIds: this.selectedIds,
          },
        );
        makeToastSuccess(data.message);
        this.$refs.moveModal.hide();
        this.selectedIds = [];
        this.loadDetail();
      } catch (err) {
        makeToastFaile(getApiErrorMessage(err));
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>
